/**
 * Core journey copy — People → Memories → Legacy Book.
 */

export const CORE_PRODUCT_PROMISE =
  'MyLegacyBridge helps families preserve memories, stories and loved ones before they are lost forever.';

export const CORE_EMOTIONAL_LINES = {
  preserveBeforeFade: 'Preserve memories before they fade.',
  startSmall: 'Start small — every story matters.',
  bookNotPerfect: 'Your Legacy Book does not need to be perfect. Start with the people and memories you already have.',
  growsOverTime: 'Your Legacy Book will grow as you add people, memories and photos.',
};

export const CORE_EMPTY_STATES = {
  noPeople: {
    title: 'Start with one person',
    description: 'Start with one person. You can add more later.',
    cta: 'Add a loved one',
  },
  noMemories: {
    title: 'Save one memory',
    description: 'Save one memory — even a small one matters.',
    ctaRecord: 'Record a memory',
    ctaWrite: 'Write a story',
  },
  noPhotos: {
    title: 'Add a photo',
    description: 'Add a photo to help this story feel alive.',
    cta: 'Add a photo',
  },
  legacyBookNotReady: {
    title: 'Your Legacy Book is waiting',
    description: CORE_EMOTIONAL_LINES.growsOverTime,
    cta: 'See what you have so far',
  },
};

export const CORE_JOURNEY_STEPS = [
  {
    id: 'first_person',
    title: 'Add your first loved one',
    hint: 'A parent, grandparent, partner or child — whoever matters most right now.',
  },
  {
    id: 'second_person',
    title: 'Add another family member',
    hint: 'You can keep the circle small. One more person is enough for now.',
  },
  {
    id: 'first_memory',
    title: 'Save your first memory',
    hint: 'A voice note, a few sentences, or one treasured moment.',
  },
  {
    id: 'first_photo',
    title: 'Add a photo',
    hint: 'A picture helps the story feel real for everyone who reads it later.',
  },
  {
    id: 'preview_book',
    title: 'Preview your Legacy Book',
    hint: 'See how what you have already saved could become a keepsake.',
  },
];

export const MEMORY_PIPELINE_LABELS = {
  uploading: 'Saving your recording…',
  queued: 'Getting ready…',
  starting: 'Preparing your words…',
  transcribing: 'Turning voice into text…',
  completed: 'Saved to this memory',
  failed: 'Could not finish — try again',
};
